import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { isTizen } from "../../../utils/platform";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    background: isTizen ? "rgba(0, 0, 0, 0.9)" : "#141414",
    justifyContent: "space-between",
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    alignItems: "center",
    zIndex: theme.zIndex.appBar + 1,
    transform: "translateY(0)",
    transition: "transform 0.5s ease-in-out",
    willChange: "transform",
    display: "flex",
    "&.hide": {
      transform: "translateY(100%)",
    },
  },
  icon: {
    height: 24,
    animation: "$fadeIn 1s ease-in-out",
  },
  itemContent: {
    height: 30,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space20,
  },
  buttonItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
    cursor: "pointer",
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
    cursor: "pointer",
    opacity: 0,
  },
  showMessage: {
    animation: "$fadeInOut 4s 1s ease-in-out",
  },
  holdLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
    borderRadius: 14,
    border: "1px solid #FFF",
    padding: "2px 4px",
  },
  "@keyframes fadeInOut": {
    "0%": {
      opacity: 0,
    },
    "20%": {
      opacity: 1,
    },
    "80%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
}));
